import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "top"
}
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  class: "text-success mb-0",
  style: {"white-space":"nowrap"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("wbr", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "text-dark mb-0",
  style: {"white-space":"nowrap"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("wbr", null, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "text-dark",
  style: {"white-space":"nowrap"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("wbr", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_12 = {
  key: 0,
  class: "text-dark mb-0"
}
const _hoisted_13 = {
  key: 1,
  class: "text-dark mb-0"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "font-weight-bold" }
const _hoisted_16 = {
  key: 3,
  class: "text-dark mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_translate = _resolveComponent("translate")!

  return (!_ctx.project)
    ? (_openBlock(), _createBlock(_component_ProgressBar, {
        key: 0,
        mode: "indeterminate"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createVNode(_component_translate, { class: "text-dark font-weight-bold" }, {
              default: _withCtx(() => [
                _createTextVNode("Phase:")
              ]),
              _: 1
            }),
            _createTextVNode("  "),
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.project.stageName), 1)
          ]),
          (_ctx.project.laterRoundActive)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _createVNode(_component_translate, { class: "text-dark font-weight-bold" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Aktueller Warteraum:")
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.project.currentApplicationRound - 1), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.project.applicationDeadline)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createVNode(_component_translate, { class: "font-weight-bold" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Teilnahmefrist:")
                  ]),
                  _: 1
                }),
                _createTextVNode("  "),
                _hoisted_8,
                _createTextVNode(_toDisplayString(_ctx.dayjs(_ctx.project.applicationDeadline).format('LLL')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.project.offerDeadline)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _createVNode(_component_translate, { class: "font-weight-bold" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Angebotsfrist:")
                  ]),
                  _: 1
                }),
                _createTextVNode("  "),
                _hoisted_10,
                _createTextVNode(_toDisplayString(_ctx.dayjs(_ctx.project.offerDeadline).format('LLL')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isProjectEditor && (_ctx.project.stage || 0) >= 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.project.firstRoundActive && _ctx.project.numberOfApplicationsByRound)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                    _createVNode(_component_translate, { class: "font-weight-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Teilnahmeanträge:")
                      ]),
                      _: 1
                    }),
                    _createTextVNode("  " + _toDisplayString(_ctx.project.numberOfApplicationsByRound[_ctx.project.currentApplicationRound || '1'] || 0), 1)
                  ]))
                : (_ctx.project.numberOfApplicationsByRound)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _createVNode(_component_translate, { class: "font-weight-bold" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Teilnahmeanträge:")
                        ]),
                        _: 1
                      }),
                      _createTextVNode("  " + _toDisplayString(_ctx.project.numberOfApplicationsByRound[_ctx.project.lastOpenedRound || '1'] || 0), 1)
                    ]))
                  : _createCommentVNode("", true),
              (_ctx.project.type === 5 && (_ctx.project.currentApplicationRound || 0) > 1 && _ctx.project.numberOfApplicationsByRound)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.project.numberOfApplicationsByRound).filter(i => Number(i) > (_ctx.project.lastOpenedRound || 1)), (i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: 'round-' + i,
                        class: "text-dark mb-0"
                      }, [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Im Warteraum")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(Number(i) - 1) + ":", 1)
                        ]),
                        _createTextVNode("  " + _toDisplayString(_ctx.project.numberOfApplicationsByRound[String(i)] || 0), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.project.stage >= 6 && _ctx.project.numberOfOffersByRound)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                    _createVNode(_component_translate, { class: "font-weight-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Angebote:")
                      ]),
                      _: 1
                    }),
                    _createTextVNode("  " + _toDisplayString(_ctx.project.numberOfOffersByRound[_ctx.project.lastOpenedRound || '1'] || 0), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
}